/**
 * Dirty real de sección: compara el estado actual con el baseline post-hidratación.
 * Evita falsos positivos de selectpicker / patchValue / valueChanges al precargar.
 */
export class PerfilSectionDirtyTracker {
  private hydrated = false;
  private baseline = '';

  get isHydrated(): boolean {
    return this.hydrated;
  }

  markBaseline(serialize: () => string): void {
    this.baseline = serialize();
    this.hydrated = true;
  }

  isDirty(serialize: () => string): boolean {
    if (!this.hydrated) {
      return false;
    }
    return serialize() !== this.baseline;
  }
}

/** Normaliza valores de form para comparar dirty sin falsos positivos (1 vs "1"). */
function normalizeFormValue(value: unknown): unknown {
  if (value == null) {
    return '';
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }
  if (typeof value === 'boolean') {
    return value ? '1' : '0';
  }
  if (Array.isArray(value)) {
    return value.map((item) => normalizeFormValue(item));
  }
  if (typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const key of Object.keys(value as Record<string, unknown>).sort()) {
      out[key] = normalizeFormValue((value as Record<string, unknown>)[key]);
    }
    return out;
  }
  return value;
}

/** Serializa form + docs/fotos para comparar dirty. */
export function serializePerfilSectionState(
  formValue: unknown,
  docs?: Record<string, { idDocumento?: number | string | null; name?: string }>
): string {
  let docsPart: Record<string, string | number> | undefined;
  if (docs) {
    docsPart = {};
    for (const key of Object.keys(docs).sort()) {
      const slot = docs[key];
      docsPart[key] = slot?.idDocumento ?? slot?.name ?? '';
    }
  }
  return JSON.stringify({
    form: normalizeFormValue(formValue ?? {}),
    docs: docsPart ?? null,
  });
}
